// Mock data for Feron Store (Souled Store style clone)

export const HERO_BANNERS = [
  {
    id: 0,
    image: '/api/files/feronstore/banners/93f5fe20b0184db8a6c35a1ed17b4350.webp',
    titleKey: 'heroGrandTitle', subKey: 'heroGrandSub', ctaKey: 'heroGrandCta',
    link: '/shop/new'
  },
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?crop=entropy&cs=srgb&fm=jpg&q=85',
    titleKey: 'hero1Title', subKey: 'hero1Sub', ctaKey: 'hero1Cta',
    link: '/shop/sale'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?crop=entropy&cs=srgb&fm=jpg&q=85',
    titleKey: 'hero2Title', subKey: 'hero2Sub', ctaKey: 'hero2Cta',
    link: '/shop/new'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1559697242-a465f2578a95?crop=entropy&cs=srgb&fm=jpg&q=85',
    titleKey: 'hero3Title', subKey: 'hero3Sub', ctaKey: 'hero3Cta',
    link: '/shop/streetwear'
  }
];

export const CATEGORY_TILES = [
  { id: 'men', image: 'https://images.unsplash.com/photo-1523398002811-999ca8dec234?crop=entropy&cs=srgb&fm=jpg&q=85', link: '/shop/men' },
  { id: 'women', image: 'https://images.pexels.com/photos/37845698/pexels-photo-37845698.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', link: '/shop/women' }
];

export const SHOP_CATEGORIES = [
  { id: 'tshirts', label: 'Oversized T-Shirts', image: 'https://images.unsplash.com/photo-1661110546797-d86cc72a2765?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 'hoodies', label: 'Hoodies', image: 'https://images.unsplash.com/photo-1564557287817-3785e38ec1f5?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 'sweatshirts', label: 'Sweatshirts', image: 'https://images.unsplash.com/photo-1578587018452-892bacefd3f2?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 'joggers', label: 'Joggers', image: 'https://images.unsplash.com/photo-1552902875-9ac1f9fe0c07?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 'shirts', label: 'Shirts', image: 'https://images.unsplash.com/photo-1588117260148-b47818741c74?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 'jackets', label: 'Jackets', image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?crop=entropy&cs=srgb&fm=jpg&q=85' }
];

const IMG_POOL = [
  'https://images.unsplash.com/photo-1588117260148-b47818741c74?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.pexels.com/photos/37845698/pexels-photo-37845698.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700',
  'https://images.pexels.com/photos/32969128/pexels-photo-32969128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700',
  'https://images.unsplash.com/photo-1523398002811-999ca8dec234?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1661110546797-d86cc72a2765?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.pexels.com/photos/36942017/pexels-photo-36942017.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700',
  'https://images.pexels.com/photos/9558567/pexels-photo-9558567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700',
  'https://images.unsplash.com/photo-1564557287817-3785e38ec1f5?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1680292783974-a9a336c10366?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1556821840-3a63f95609a7?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1542291026-7eec264c27ff?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.pexels.com/photos/1027130/pexels-photo-1027130.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700',
  'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1581605405669-fcdf81165afa?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1622560480654-d96214fdc887?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1560774358-d727658f457c?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1521369909029-2afed882baee?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1578587018452-892bacefd3f2?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1618354691551-44de113f0164?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1552902875-9ac1f9fe0c07?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1580906853305-5702e648164e?crop=entropy&cs=srgb&fm=jpg&q=85'
];

const COLLECTIONS = ['Marvel', 'DC Comics', 'Star Wars', 'Friends', 'Harry Potter', 'Feron Originals', 'Anime Edit', 'F.R.I.E.N.D.S', 'Naruto', 'Peanuts'];
const TSHIRT_NAMES = ['Iron Man: Suit Up', 'Batman: Gotham', 'Deadpool: Chimichanga', 'Joey Doesn\u2019t Share', 'Solid: Black', 'Solid: White', 'Vintage Rockstar', 'Skater Boy', 'Groot Vibes', 'Wakanda Forever', 'Sherlock: Not Your Housekeeper', 'Ross: We Were On A Break'];
const PRODUCT_TYPES = [
  { type: 'Oversized T-Shirts', priceRange: [799, 1499] },
  { type: 'Hoodies', priceRange: [1499, 2499] },
  { type: 'Sweatshirts', priceRange: [1299, 1999] },
  { type: 'Joggers', priceRange: [1199, 1799] },
  { type: 'Shirts', priceRange: [1099, 1799] }
];

function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

function generateProducts() {
  const products = [];
  let id = 1;
  PRODUCT_TYPES.forEach((pt) => {
    for (let i = 0; i < 12; i++) {
      const mrp = rand(pt.priceRange[0], pt.priceRange[1]);
      const discount = rand(15, 65);
      const price = Math.floor(mrp * (100 - discount) / 100);
      const collection = COLLECTIONS[rand(0, COLLECTIONS.length - 1)];
      const nameBase = TSHIRT_NAMES[rand(0, TSHIRT_NAMES.length - 1)];
      const img1 = IMG_POOL[rand(0, IMG_POOL.length - 1)];
      const img2 = IMG_POOL[rand(0, IMG_POOL.length - 1)];
      products.push({
        id: id++,
        name: `${collection}: ${nameBase}`,
        type: pt.type,
        category: pt.type.toLowerCase().replace(/ /g, '-'),
        gender: ['men', 'women'][rand(0, 1)],
        mrp,
        price,
        discount,
        rating: (3.8 + Math.random() * 1.2).toFixed(1),
        reviews: rand(50, 3000),
        images: [img1, img2, img1],
        image: img1,
        hoverImage: img2,
        sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
        colors: ['Black', 'White', 'Navy', 'Olive'].slice(0, rand(2, 4)),
        collection,
        description: `Officially licensed ${collection} merchandise. Premium 100% cotton blend, oversized fit. Iconic design printed with high-quality inks that don't fade.`,
        inStock: true
      });
    }
  });
  return products;
}

export const PRODUCTS = generateProducts();

export const BRAND_COLLABS = [
  { id: 1, name: 'Marvel', image: 'https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 2, name: 'DC Comics', image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 3, name: 'Friends', image: 'https://images.unsplash.com/photo-1618354691551-44de113f0164?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 4, name: 'Star Wars', image: 'https://images.unsplash.com/photo-1680292783974-a9a336c10366?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { id: 5, name: 'Harry Potter', image: 'https://images.pexels.com/photos/9558567/pexels-photo-9558567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 6, name: 'Peanuts', image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?crop=entropy&cs=srgb&fm=jpg&q=85' }
];

export const OFFER_STRIP = [
  'FREE WORLDWIDE SHIPPING',
  'SECURE PAYMENTS',
  '30 DAYS EASY RETURNS & EXCHANGES',
  'BUY 3 GET 20% OFF | CODE: FERON20'
];

export const NAV_MENU = {
  MEN: {
    'Topwear': ['Oversized T-Shirts', 'T-Shirts', 'Shirts', 'Hoodies', 'Sweatshirts', 'Jackets', 'Polos'],
    'Bottomwear': ['Joggers', 'Jeans', 'Trousers', 'Shorts', 'Pyjamas'],
    'Footwear': ['Sneakers', 'Sliders'],
    'Accessories': ['Backpacks', 'Caps', 'Boxers', 'Socks', 'Masks']
  },
  WOMEN: {
    'Topwear': ['Oversized T-Shirts', 'T-Shirts', 'Shirts', 'Hoodies', 'Sweatshirts', 'Dresses', 'Crop Tops'],
    'Bottomwear': ['Joggers', 'Jeans', 'Skirts', 'Shorts'],
    'Footwear': ['Sneakers', 'Sliders'],
    'Accessories': ['Backpacks', 'Caps', 'Socks']
  },
  SNEAKERS: {
    'Shop by Style': ['High Tops', 'Low Tops', 'Classic', 'Chunky'],
    'Collections': ['Marvel', 'Star Wars', 'Feron Originals']
  }
};
